<template>
    <div id="contenedor-album-listado-desktop">
        <v-container
            fluid>
        <v-card
            flat>
            <v-list
                flat>
                <!--Titulo Partida-->
                <v-list-group
                :value="true"
                v-for="partida in getContratoFotos"
                :key="partida.idpartida"
                class="base4 font-weight-bold primary--text h2 pa-3"
                >
                    <template v-slot:activator>
                        <v-list-item-title class="base4 font-weight-bold primary--text h2 pa-4">
                            {{ partida.concepto.slice(0,130) }}...
                        <v-chip v-if="modulo === 'consultas'">{{partida.avanceFisico}} %</v-chip>
                        </v-list-item-title>
                        <v-spacer></v-spacer>
                        <v-tooltip bottom color="verde2">
                            <template v-slot:activator="{ on, attrs }">
                            <v-btn class="secondary--text"
                                @click="descargarZip(partida)"
                                icon
                                :loading="mostrarDescargando
                                && (imagenSeleccionDescarga === partida.idpartida)"
                                v-bind="attrs"
                                v-on="on"
                            >
                            <v-icon color="blue darken-1">
                                mdi-cloud-download
                            </v-icon>
                            </v-btn>
                            </template>
                            <span>Descargar fotos de esta partida</span>
                            </v-tooltip>
                    </template>
                    <!--Listado de Imagenes-->
                    <v-row class="bkground font-weight-bold primary--text h2 pa-3">
                        <v-col
                        v-for="img in partida.imagenes"
                        :key="img.imagen"
                        class="d-flex child-flex"
                        cols="3"
                        >
                        <v-card style="text-aling:center;" flat>
                            <v-img
                                :src="`${$urlFileServer}/${img.imagen}/thumbnail`"
                                :lazy-src="`${$urlFileServer}/${img.imagen}/thumbnail`"
                                aspect-ratio="1"
                                max-height="150"
                                max-width="100%"
                                class="grey lighten-2"
                                @click="clickMostrarVentanaZoomImagen(partida.imagenes, img.imagen)"
                                style="cursor: pointer;"
                            >
                                <template v-slot:placeholder>
                                <v-row
                                    class="fill-height ma-0"
                                    align="center"
                                    justify="center"
                                >
                                    <v-progress-circular
                                    indeterminate
                                    color="grey lighten-5"
                                    ></v-progress-circular>
                                </v-row>
                                </template>

                            </v-img>
                            <v-card-subtitle class="secondary--text pa-1">
                            <v-row >
                                <v-col class="d-flex justify-space-between">
                                <v-chip color="base5" class="primary--text pa-4">
                                {{ new Date(`${img.fecha} 00:00:0`).toLocaleDateString('es-MX') }}
                                </v-chip>

                                <v-spacer></v-spacer>

                                <v-tooltip bottom color="verde2" >
                                    <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="secondary--text"
                                        @click="descargarImagen(img.imagen, partida)"
                                        icon
                                        :loading="mostrarDescargando
                                        && (imagenSeleccionDescarga === img.imagen)"
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                        <v-icon color="blue darken-1">
                                            mdi-cloud-download
                                        </v-icon>
                                    </v-btn>
                                    </template>
                                <span style="color:primary;">Descargar esta foto</span>
                                </v-tooltip>
                                </v-col>
                            </v-row>
                            </v-card-subtitle>
                        </v-card>
                        </v-col>
                    </v-row>
                </v-list-group>
            </v-list>
        </v-card>
        </v-container>

        <!--Ventana Zoom Imagenes-->
        <v-dialog
        ref="ventanaAlbumZoomImagen"
        v-model="mostrarVentanaZoomImagen"
        width="55%"
        heigth= "30%"
        persistent
        >
            <v-card>
                <v-card-title class="secondary--text">
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        @click="cerrar">
                        <v-icon class="secondary--text" large>highlight_off</v-icon>
                    </v-btn>
                </v-card-title>

                <v-carousel
                    hide-delimiter-background
                    show-arrows-on-hover
                    >
                    <v-carousel-item
                        v-for="i in imagenesZoom"
                        :key="i.imagen"
                        :src="`${$urlFileServer}/${i.imagen}`"
                        :lazy-src="`${$urlFileServer}/${i.imagen}`"
                        max-width="100%"
                        max-heigth="100%"
                        contain
                        aspect-ratio="16/9"
                        reverse-transition="fade-transition"
                        transition="fade-transition"
                    >
                    <v-row
                        class="fill-height"
                        justify="center"
                    >
                        <div class="text-h6 center">
                            {{ new Date(`${i.fecha} 00:00:0`).toLocaleDateString('es-MX') }}
                        </div>
                    </v-row>
                    </v-carousel-item>
                </v-carousel>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
import mixAlbumFotografico from '@/components/administracion/album/listado/mixAlbumFotografico';
import mixDescargaImagen from '@/helpers/mixDescargaImagen';

export default {
  name: 'AlbumListadoDesktop',
  props: {
    reportesFisicos: {
      type: Array,
      required: true,
    },
    contrato: {
      type: Object,
      required: true,
    },
    modulo: {
      type: String,
      required: false,
      default: '',
    },
  },
  components: {

  },
  mixins: [
    mixDescargaImagen, mixAlbumFotografico,
  ],
  data() {
    return {
      mostrarDescargando: false,
      imagenSeleccionDescarga: '',
      mostrarVentanaZoomImagen: false,
      imagenesZoom: [],
    };
  },
  computed: {
    contratoNumero() {
      if (!this.contrato.numero) return 'noNumero';
      return this.contrato.numero;
    },
  },
};
</script>
